var _rect, _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEngage = function SvgEngage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 110 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 80,
    rx: 8,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.77 51.488 50.389 65.87 46 70.5 34.5 59l-7.122-7.123a3.998 3.998 0 0 1 .052-5.705l4.28-4.13 11.807-11.807L64.77 51.488Z",
    fill: "url(#engage_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "m51.994 64.264-3.731 3.73c-1.346 1.347-3.4 1.323-4.77 0l-16.53-16.53c-1.3-1.298-1.276-3.4.023-4.699l4.723-4.723c1.346-1.298 3.377-1.298 4.723 0a3.307 3.307 0 0 1 .307 4.322l-1.299 1.299a3.385 3.385 0 0 0 0 4.77c1.299 1.299 3.566 1.251 4.77 0l4.51-4.51c.992-.992 2.41-1.465 3.755-1.394 1.228.047 2.433.496 3.33 1.393 1.913 1.96 1.936 5.149 0 7.085L47.27 59.54c-1.322 1.322-1.322 3.4-.023 4.7 1.298 1.298 3.447 1.321 4.746.023Z",
    fill: "#5298F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m66.87 49.386-2.101 2.102-3.77-3.988-7.5-7.5-5.5-5.5-4.483-4.265 2.101-2.102c1.347-1.346 3.306-1.842 5.101-1.228l3.566 1.205c2.007.685 4.25 0 5.526-1.653l8.808-11.359a8.022 8.022 0 0 1 6.353-3.093 8.157 8.157 0 0 1 5.667 2.361A8.16 8.16 0 0 1 83 20.034a8.067 8.067 0 0 1-3.117 6.328L68.57 35.171a5.006 5.006 0 0 0-1.676 5.55l1.157 3.518c.613 1.841.141 3.778-1.181 5.147ZM75 23a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
    fill: "url(#engage_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "engage_svg__a",
    x1: 39.389,
    y1: 26,
    x2: 39.389,
    y2: 71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "engage_svg__b",
    x1: 63.258,
    y1: 12.005,
    x2: 63.258,
    y2: 51.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};

export default SvgEngage;